import { getRequest } from '../../../api/api';

export function getEWalletBalanceData(callbackResponse) {
    return getRequest(
        'api/v1/wallet/net-fund',
        null,
        callbackResponse
    );
};

export function getInvestmentNotes(page, params) {
    return getRequest(
        'api/v1/investment/notes?page=' + page,
        params,
    );
};

export function getThemeList(callbackResponse) {
    getRequest(
        'api/v1/investment/theme-list',
        null,
        callbackResponse
    );
};
